"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var ChatQueueBroker_1 = __importDefault(require("./ChatQueueBroker"));
function ChatQueueListener(props) {
    var chat = props.chat, onUpload = props.onUpload;
    var rooms = chat.rooms;
    if (lodash_1["default"].isEmpty(rooms))
        return null;
    var roomIds = Object.keys(rooms);
    return (react_1["default"].createElement(react_1["default"].Fragment, null, lodash_1["default"].map(roomIds, function (roomId) {
        var room = rooms[roomId];
        if (lodash_1["default"].isEmpty(room.messageQueue))
            return null;
        return react_1["default"].createElement(ChatQueueBroker_1["default"], { room: room, key: "chat-queue-broker-" + roomId, onUpload: onUpload });
    })));
}
var connectStore = react_redux_1.connect(function (state) { return ({
    chat: state.chat
}); });
exports["default"] = connectStore(ChatQueueListener);
